/* Name:Chaitali Khachane
   Description:this page contain all the component(with their css) required for most of the screens */


import styled from "styled-components";

export const Container = styled.div`
padding:12px 40px;
`
export const GlobalCardTitle = styled.span`
// font-family: Mars Centra;
color:black;
font-size: 16px;
font-weight: 700;
line-height: 20.8px;
text-align: left;
text-underline-position: from-font;
text-decoration-skip-ink: none;
`
export const CardBodyTitle = styled.span`
// font-family: Mars Centra;
font-size: 12px;
font-weight: 700;
line-height: 18.2px;
text-align: left;
text-underline-position: from-font;
text-decoration-skip-ink: none;

`
export const TableHeader = styled.span`
// font-family: Mars Centra;
font-size: 14px;
font-weight: 700;
line-height: 18.2px;
text-align: left;
text-underline-position: from-font;
text-decoration-skip-ink: none;

`
export const UnderlineGlobalValue = styled.span`
font-size: 12px;
font-weight: 400;
line-height: 15.6px;
text-align: left;
text-decoration-line: underline;
text-decoration-style: solid;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color: #0000A0;
`
export const ErrorMsg = styled.div`
font-family: Mars Centra;
font-size: 14px;
font-weight: 400;
line-height: 18.2px;
text-align: left;
text-decoration-line: underline;
text-decoration-style: solid;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color: #FF1414CC;
margin:10px;

`
export const FieldLabel = styled.label`
color: #4b5563;
font-size: 13.3333px;
font-weight: 700;
`
